import ClientsList from "../../components/Clients/ClientsList";

const clientsRoutes = [
    {
        path: '', name: 'Clients',
        component: ClientsList,
        meta: { title: 'Clients', resource: 'clients', action: 'view' },
    },
];

export default clientsRoutes;
